import { render, staticRenderFns } from "./routerHistory.vue?vue&type=template&id=2b235dcf&scoped=true"
import script from "./routerHistory.vue?vue&type=script&lang=js"
export * from "./routerHistory.vue?vue&type=script&lang=js"
import style0 from "./routerHistory.vue?vue&type=style&index=0&id=2b235dcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b235dcf",
  null
  
)

export default component.exports